import { render, staticRenderFns } from "./PdpImage.vue?vue&type=template&id=8115ea2e&scoped=true&"
import script from "./PdpImage.vue?vue&type=script&lang=js&"
export * from "./PdpImage.vue?vue&type=script&lang=js&"
import style0 from "./PdpImage.vue?vue&type=style&index=0&id=8115ea2e&prod&lang=postcss&scoped=true&"
import style1 from "./PdpImage.vue?vue&type=style&index=1&id=8115ea2e&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8115ea2e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconThreeSixty: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconThreeSixty.vue').default,SvgIconStylefitClose: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconStylefitClose.vue').default,PdpImageSwiper: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpImageSwiper.vue').default,ShopifyImage: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/ShopifyImage.vue').default,SvgIconZoomIn: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconZoomIn.vue').default,PdpAugRealityModal: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpAugRealityModal.vue').default})
